import { Button, Stack } from '@etg/wings';
import { variants } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { CaretRight } from '@phosphor-icons/react';
import { jsx as _jsx } from "react/jsx-runtime";
const continueIconStyles = css`
  [dir='rtl'] & {
    transform: rotate(180deg);
  }
`;
const SeatMapFooter = _ref => {
  let {
    onClose,
    onSaveAndContinue,
    shouldShowSummary
  } = _ref;
  const {
    t
  } = useTranslation();
  const saveAndContinueLabel = t('Product.SeatMap.Button.Continue');
  const handleClose = e => {
    if (!shouldShowSummary) {
      onSaveAndContinue(e);
      return;
    }
    onClose(e);
  };
  return /*#__PURE__*/_jsx(Stack, {
    align: "end",
    "data-testid": "seatMapFooter",
    children: /*#__PURE__*/_jsx(Button, {
      "data-testid": "saveAndContinue-button",
      iconSuffix: /*#__PURE__*/_jsx(CaretRight, {
        className: continueIconStyles
      }),
      onClick: handleClose,
      variant: variants.PRIMARY,
      children: saveAndContinueLabel
    })
  });
};
export default SeatMapFooter;
//# sourceMappingURL=SeatMapFooter.js.map